import { reactive, Ref, toRefs } from '@vue/composition-api';
import { AxiosError } from 'axios';

type UseApiReturnType<T> = {
  handleApi: (args: any) => Promise<T | null>;
  errors: Ref<ApiErrorResponse | null>;
  isLoading: Ref<boolean>;
};

type ApiErrorResponse = {
  message: string;
  status: number;
  reason: Record<string, string>;
};

export type UseApi = {
  <T>(apiFunc: (args: any) => Promise<T>): UseApiReturnType<T>;
};

export const useApi: UseApi = (apiFunc) => {
  const state = reactive<{
    errors: ApiErrorResponse | null;
    isLoading: boolean;
  }>({
    errors: null,
    isLoading: false,
  });

  const handleApi = async (args: any) => {
    state.isLoading = true;

    return await apiFunc(args)
      .then((apiResponse) => {
        state.errors = null;
        return apiResponse;
      })
      .catch((err: AxiosError<ApiErrorResponse>) => {
        const res = err.response;
        if (!res) return null;

        state.errors = {
          message: res.data?.message,
          status: res.status || 500,
          reason: res.data.reason,
        };
        return null;
      })
      .finally(() => {
        state.isLoading = false;
      });
  };

  return {
    handleApi,
    ...toRefs(state),
  };
};
